var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "px-10 my-3", attrs: { fluid: "" } },
    [
      _c(
        "portal",
        { attrs: { to: "page-title" } },
        [
          _c("v-breadcrumbs", {
            attrs: {
              items: [
                { text: _vm.$tc("labels.general", 2), disabled: false },
                { text: _vm.$t("labels.jobStatus"), disabled: false }
              ]
            },
            scopedSlots: _vm._u([
              {
                key: "divider",
                fn: function() {
                  return [
                    _c("v-icon", { attrs: { size: "8" } }, [
                      _vm._v("\n          far fa-chevron-right\n        ")
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "v-card",
        { attrs: { id: "jobStatus" } },
        [
          _c(
            "v-row",
            { staticClass: "actions", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                [
                  _c("v-text-field", {
                    staticClass:
                      "name-filter pt-3 pb-1 ml-4 extra-dense-text-field d-inline-block",
                    attrs: {
                      "append-icon": _vm.filters.name ? "" : "fal fa-search",
                      clearable: !!_vm.filters.name,
                      dense: "",
                      "hide-details": "",
                      placeholder: _vm.$t("labels.searchByName"),
                      solo: ""
                    },
                    model: {
                      value: _vm.filters.name,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.filters,
                          "name",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "filters.name"
                    }
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "float-right mt-2 mr-4",
                      attrs: { color: "secondary" },
                      on: {
                        click: function($event) {
                          return _vm.openJobStatusDialog()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("labels.addJobStatus")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-data-table", {
            directives: [
              {
                name: "resize",
                rawName: "v-resize.quiet",
                value: _vm.onWindowResized,
                expression: "onWindowResized",
                modifiers: { quiet: true }
              }
            ],
            attrs: {
              "fixed-header": "",
              headers: _vm.headers,
              "header-props": { sortIcon: "fa fa-arrow-up" },
              "hide-default-footer": "",
              items: _vm.paginatedJobStatus,
              "items-per-page": _vm.pagination.itemsPerPage,
              "must-sort": "",
              "single-select": "",
              "sort-by": _vm.sort.by,
              "sort-desc": _vm.sort.desc
            },
            on: {
              "update:sortBy": function($event) {
                return _vm.$set(_vm.sort, "by", $event)
              },
              "update:sort-by": function($event) {
                return _vm.$set(_vm.sort, "by", $event)
              },
              "update:sortDesc": function($event) {
                return _vm.$set(_vm.sort, "desc", $event)
              },
              "update:sort-desc": function($event) {
                return _vm.$set(_vm.sort, "desc", $event)
              }
            },
            scopedSlots: _vm._u([
              {
                key: "header.description",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c("span", { staticClass: "grey--text text--darken-3" }, [
                      _vm._v(
                        "\n          " + _vm._s(header.text) + "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "header.shortCode",
                fn: function(ref) {
                  var header = ref.header
                  return [
                    _c("span", { staticClass: "grey--text text--darken-3" }, [
                      _vm._v(
                        "\n          " + _vm._s(header.text) + "\n        "
                      )
                    ])
                  ]
                }
              },
              {
                key: "item",
                fn: function(ref) {
                  var item = ref.item
                  var tableHeaders = ref.headers
                  return [
                    _c(
                      "tr",
                      {
                        class: item.obsolete ? "obsolete" : "",
                        on: {
                          mouseenter: function($event) {
                            _vm.hoveredItem = item
                          },
                          mouseleave: function($event) {
                            _vm.hoveredItem = null
                          }
                        }
                      },
                      [
                        _vm._l(tableHeaders, function(header) {
                          return _c(
                            "td",
                            { key: header.value, staticClass: "text-start" },
                            [
                              header.value === "name"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block",
                                      style: { width: header.width + "px" },
                                      attrs: { title: item.name }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.name) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              header.value === "description"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block",
                                      style: { width: header.width + "px" },
                                      attrs: { title: item.description }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.description) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              header.value === "shortCode"
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "grey--text text--darken-3 text-truncate d-block text-capitalize",
                                      style: { width: header.width + "px" },
                                      attrs: { title: item.shortCode }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(item.shortCode) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              header.value === "benefited"
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "d-inline-block",
                                        style: { "min-width": "80px" }
                                      },
                                      [
                                        item.benefited
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "success",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  fas fa-check-circle\n                "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "grey",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  far fa-times-circle\n                "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e(),
                              header.value === "registry"
                                ? [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "d-inline-block",
                                        style: { "min-width": "80px" }
                                      },
                                      [
                                        item.registry
                                          ? _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "success",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  fas fa-check-circle\n                "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  color: "grey",
                                                  small: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  far fa-times-circle\n                "
                                                )
                                              ]
                                            )
                                      ],
                                      1
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        }),
                        _c(
                          "v-speed-dial",
                          {
                            staticClass: "mt-6 job-status-dial",
                            attrs: {
                              absolute: "",
                              value:
                                _vm.hoveredItem &&
                                _vm.hoveredItem.id === item.id,
                              right: "",
                              direction: "left",
                              transition: "slide-x-reverse-transition"
                            }
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "edit",
                                attrs: {
                                  fab: "",
                                  height: "30",
                                  width: "30",
                                  title: _vm.$t("labels.editJobStatus")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openJobStatusDialog(item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v(
                                    "\n                fal fa-pencil\n              "
                                  )
                                ])
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "delete",
                                attrs: {
                                  fab: "",
                                  height: "30",
                                  width: "30",
                                  title: _vm.$t("labels.deleteJobStatus")
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.openDeleteConfirmationDialog(
                                      item
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { color: "error", small: "" } },
                                  [
                                    _vm._v(
                                      "\n                fal fa-trash-alt\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ]
                }
              },
              {
                key: "footer",
                fn: function() {
                  return [
                    _c("v-pagination", {
                      staticClass: "py-4 footer",
                      attrs: {
                        color: "secondary",
                        length: _vm.numberOfPages,
                        "next-icon": "far fa-chevron-right",
                        "prev-icon": "far fa-chevron-left",
                        "total-visible": _vm.pagination.maxPaginationControls
                      },
                      model: {
                        value: _vm.pagination.currentPage,
                        callback: function($$v) {
                          _vm.$set(_vm.pagination, "currentPage", $$v)
                        },
                        expression: "pagination.currentPage"
                      }
                    })
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm.showJobStatusDialog
        ? _c(
            "v-dialog",
            {
              attrs: {
                persistent: "",
                width: "500px",
                value: _vm.showJobStatusDialog
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "pa-0", attrs: { id: "jobStatusDialog" } },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "body-2 d-block mb-2" },
                    [
                      _c("span", { staticClass: "body-2 font-weight-medium" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.selectedJobStatus.id
                                ? _vm.$t("labels.editJobStatus")
                                : _vm.$t("labels.addJobStatus")
                            ) +
                            "\n        "
                        )
                      ]),
                      _c(
                        "v-btn",
                        {
                          staticClass: "float-right mt-n1",
                          attrs: { disabled: _vm.saving, icon: "", small: "" },
                          on: { click: _vm.closeJobStatusDialog }
                        },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("\n            fal fa-times\n          ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-card-text",
                    { staticClass: "px-0" },
                    [
                      _c("ValidationObserver", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var invalid = ref.invalid
                                var passes = ref.passes
                                return [
                                  _c(
                                    "v-form",
                                    { staticClass: "job-status" },
                                    [
                                      _c(
                                        "v-container",
                                        { staticClass: "pt-0 px-6" },
                                        [
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", sm: "6" }
                                                },
                                                [
                                                  _c("VeeTextField", {
                                                    attrs: {
                                                      dense: "",
                                                      label: _vm.$t(
                                                        "labels.name"
                                                      ),
                                                      name: "name",
                                                      outlined: "",
                                                      rules: {
                                                        required: true,
                                                        max: 32,
                                                        excluded: _vm.namesInUse
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedJobStatus
                                                          .name,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobStatus,
                                                          "name",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobStatus.name"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-col",
                                                {
                                                  attrs: { cols: "12", sm: "6" }
                                                },
                                                [
                                                  _c("VeeTextField", {
                                                    attrs: {
                                                      dense: "",
                                                      label: _vm.$t(
                                                        "labels.description"
                                                      ),
                                                      name: "description",
                                                      outlined: "",
                                                      rules: "max:256"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedJobStatus
                                                          .description,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobStatus,
                                                          "description",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobStatus.description"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("VeeTextField", {
                                                    attrs: {
                                                      dense: "",
                                                      label: _vm.$t(
                                                        "labels.shortcode"
                                                      ),
                                                      name: "shortcode",
                                                      outlined: "",
                                                      rules: "required|max:4"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedJobStatus
                                                          .shortCode,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobStatus,
                                                          "shortCode",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobStatus.shortCode"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("v-switch", {
                                                    staticClass:
                                                      "pt-0 mt-1 d-inline-block",
                                                    attrs: {
                                                      color: "success",
                                                      dense: "",
                                                      "hide-details": "",
                                                      inset: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mr-4 body-2 grey--text text--darken-3",
                                                                  attrs: {
                                                                    title: _vm.$t(
                                                                      "labels.benefited"
                                                                    )
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.benefited"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedJobStatus
                                                          .benefited,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobStatus,
                                                          "benefited",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobStatus.benefited"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c("v-switch", {
                                                    staticClass:
                                                      "pt-0 mt-1 d-inline-block",
                                                    attrs: {
                                                      color: "success",
                                                      dense: "",
                                                      "hide-details": "",
                                                      inset: ""
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "label",
                                                          fn: function() {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "mr-4 body-2 grey--text text--darken-3",
                                                                  attrs: {
                                                                    title: _vm.$t(
                                                                      "labels.registry"
                                                                    )
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                        " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "labels.registry"
                                                                        )
                                                                      ) +
                                                                      "\n                      "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          },
                                                          proxy: true
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                    model: {
                                                      value:
                                                        _vm.selectedJobStatus
                                                          .registry,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.selectedJobStatus,
                                                          "registry",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "selectedJobStatus.registry"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "my-4",
                                              attrs: {
                                                dense: "",
                                                "no-gutters": ""
                                              }
                                            },
                                            [
                                              _c("v-col", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "grey--text text--darken-3 body-2"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "labels.selfScheduleRules"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "grey--text caption"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "labels.selfScheduleRulesHint"
                                                          )
                                                        ) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              ])
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-row",
                                            {
                                              staticClass: "mt-4",
                                              attrs: { dense: "" }
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "v-card",
                                                    {
                                                      staticClass:
                                                        "grey lighten-4 self-schedule-rules",
                                                      attrs: { elevation: 0 }
                                                    },
                                                    [
                                                      _vm.selectedJobStatus
                                                        .minShiftSettings
                                                        ? _c(
                                                            "v-container",
                                                            {
                                                              staticClass:
                                                                "pb-0 pt-6"
                                                            },
                                                            [
                                                              _vm._l(
                                                                _vm
                                                                  .selectedJobStatus
                                                                  .minShiftSettings
                                                                  .countRules
                                                                  .weekend,
                                                                function(
                                                                  rule,
                                                                  idx
                                                                ) {
                                                                  return [
                                                                    _c(
                                                                      "v-row",
                                                                      {
                                                                        key:
                                                                          "count-" +
                                                                          idx,
                                                                        attrs: {
                                                                          dense:
                                                                            ""
                                                                        }
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            attrs: {
                                                                              cols:
                                                                                "9"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticClass:
                                                                                  "grey--text text--darken-3 body-2 label"
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                              " +
                                                                                    _vm._s(
                                                                                      _vm.$t(
                                                                                        "labels.minShiftRule"
                                                                                      )
                                                                                    ) +
                                                                                    "\n                            "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "v-col",
                                                                          {
                                                                            staticClass:
                                                                              "text-right",
                                                                            attrs: {
                                                                              cols:
                                                                                "3"
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "VeeTextField",
                                                                              {
                                                                                attrs: {
                                                                                  dense:
                                                                                    "",
                                                                                  maxlength:
                                                                                    "3",
                                                                                  name:
                                                                                    "minShiftCount" +
                                                                                    idx,
                                                                                  outlined:
                                                                                    "",
                                                                                  rules:
                                                                                    "numeric"
                                                                                },
                                                                                on: {
                                                                                  input: function(
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.validateMinShiftCount(
                                                                                      idx
                                                                                    )
                                                                                  }
                                                                                },
                                                                                model: {
                                                                                  value:
                                                                                    rule.count,
                                                                                  callback: function(
                                                                                    $$v
                                                                                  ) {
                                                                                    _vm.$set(
                                                                                      rule,
                                                                                      "count",
                                                                                      _vm._n(
                                                                                        $$v
                                                                                      )
                                                                                    )
                                                                                  },
                                                                                  expression:
                                                                                    "rule.count"
                                                                                }
                                                                              }
                                                                            )
                                                                          ],
                                                                          1
                                                                        )
                                                                      ],
                                                                      1
                                                                    )
                                                                  ]
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("v-divider"),
                                      _c(
                                        "v-row",
                                        { attrs: { dense: "" } },
                                        [
                                          _c(
                                            "v-col",
                                            {
                                              staticClass:
                                                "text-right pb-0 pt-4 px-8",
                                              attrs: { cols: "12" }
                                            },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mr-4",
                                                  attrs: {
                                                    disabled: _vm.saving,
                                                    text: ""
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.closeJobStatusDialog
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.$t("labels.cancel")
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                              ),
                                              _vm.selectedJobStatus.id
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "submit",
                                                      attrs: {
                                                        color: "secondary",
                                                        disabled:
                                                          invalid || _vm.saving
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return passes(
                                                            _vm.update
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.saving
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary lighten-2",
                                                                indeterminate:
                                                                  "",
                                                                size: "22",
                                                                width: "2"
                                                              }
                                                            }
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "labels.save"
                                                                  )
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ])
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "submit",
                                                      attrs: {
                                                        color: "secondary",
                                                        disabled:
                                                          invalid || _vm.saving
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return passes(_vm.add)
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm.saving
                                                        ? _c(
                                                            "v-progress-circular",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary lighten-2",
                                                                indeterminate:
                                                                  "",
                                                                size: "22",
                                                                width: "2"
                                                              }
                                                            }
                                                          )
                                                        : _c("span", [
                                                            _vm._v(
                                                              "\n                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "labels.add"
                                                                  )
                                                                ) +
                                                                "\n                  "
                                                            )
                                                          ])
                                                    ],
                                                    1
                                                  )
                                            ],
                                            1
                                          ),
                                          _c("v-spacer")
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1855893605
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.deleteDialog.show
        ? _c("DeleteConfirmation", {
            attrs: {
              action: "org/checkJobStatusDependencies",
              "delete-body": _vm.$t("descriptions.continueDeleteJobStatus", {
                name: _vm.deleteDialog.jobStatus.name
              }),
              "dependencies-body": _vm.$t(
                "descriptions.hasDependenciesJobStatus",
                { name: _vm.deleteDialog.jobStatus.name }
              ),
              item: _vm.deleteDialog.jobStatus,
              title: _vm.$t("labels.deleteJobStatus?")
            },
            on: {
              close: _vm.closeDeleteConfirmationDialog,
              del: _vm.deleteJobStatus
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }